export enum TypeRequest {
    get = 'get',
    post = 'post',
    put = 'put',
    delete = 'delete'
}

export enum VisualizacionFormulario {
    Listado = "Listado",
    Mapa = "Mapa",
    ListadoDetalle = "ListadoDetalle",
    Tabla = "Tabla"
}

export enum PreguntaTipo {
    Texto = "Texto",
    Numerico = "Numerico",
    Imagen = "Imagen",
    Fecha = "Fecha",
    FechaHora = "FechaHora",
    Hora = "Hora",
    Seleccion = "Seleccion",
    SeleccionMultiple = "SeleccionMultiple",
    Coordenadas = "Coordenadas",
    CamaraGaleria = "CamaraGaleria",
    Galeria = "Galeria",
    Archivo = "Archivo",
    FechaRango = "FechaRango",
    FechaRangoMultiple = "FechaRangoMultiple"
}

export enum DetalleTipo {
    Texto = "Texto",
    Mapa = "Mapa",
    BotonLLamar = "BotonLLamar"
}

export enum TypeColumn {
    Codigo = 1,
    Nombre = 2,
    Coordenadas = 3,
    Latitud = 4,
    Longitud = 5,
    Telefono1 = 6,
    Telefono2 = 7,
    Telefono3 = 8,
    AtributoListado = 9
}

export enum OptionTypeAnswer {
    NA = 1,
    Manual = 2,
    Query = 3
}